import { render, staticRenderFns } from "./MenuGeneratorLink.vue?vue&type=template&id=3a033f7c"
import script from "./MenuGeneratorLink.vue?vue&type=script&lang=js"
export * from "./MenuGeneratorLink.vue?vue&type=script&lang=js"
import style0 from "./MenuGeneratorLink.vue?vue&type=style&index=0&id=3a033f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports